export default "__VITE_ASSET__yd9C8ix2__"